module.exports = __webpack_public_path__ + "static/media/background.c80b23ff.jpg";